module.exports = __webpack_public_path__ + "media/audio58.d1d54b34.mp3";